module.exports = __webpack_public_path__ + "static/img/productPartner_4_1.5926938.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_4_1.png
// module id = LWSf
// module chunks = 34